export default __webpack_public_path__ + "static/media/favorites-airstrapzwhite-comp.a54769a8.png";